import * as React from 'react';

import {
  CreatePortalSessionEventAdapter,
  CreatePortalSessionEventData,
} from '~analytics/adapters/CreatePortalSessionEventAdapter';

import { createCustomerPortalSessionUrl } from '../../../api/sales/salesUrls';

export interface CustomerPortalSessionFormProps
  extends React.HTMLProps<HTMLFormElement> {
  source: CreatePortalSessionEventData['source'];
  teamId: string;
  children: React.ReactNode;
  onSubmit?: () => void;
}

export function CustomerPortalSessionForm({
  children,
  onSubmit,
  source,
  teamId,
  ...props
}: CustomerPortalSessionFormProps) {
  const customerPortalSessionUrl = createCustomerPortalSessionUrl().href;
  return (
    <form
      method="post"
      action={customerPortalSessionUrl}
      onSubmit={() => {
        onSubmit?.();
        new CreatePortalSessionEventAdapter({
          source: source,
          team_id: teamId,
        }).sendAnalytics();
      }}
      {...props}
    >
      {children}
    </form>
  );
}
